import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { State } from './state';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ServiceLevelService {


    constructor(private http: HttpClient) {
    }

    getServiceLevels() {
      const headers =  State.getAuthHeaders();
      let params = new HttpParams().append('providerId', ''+environment.providerId);
        return this.http.get(State.config.host+  '/api/service-levels', {params: params, headers: headers}).pipe(map((r: any) => {
          return r;
        },  (error: any) => {
              throw error;
            }));
    }
  }